import ForgetPassword from 'components/authentication/split/ForgetPassword';
import LoginInmobiliario from 'components/authentication/split/LoginInmobiliario';
import RestablecerContraseña from 'components/authentication/split/RestablecerContraseña';
import AppContext from 'context/Context';
import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate
} from 'react-router-dom';
import { checkSession } from 'redux/loginSlice';
import RoutesAyuda from 'routes/RoutesAyuda';
import RoutesCucicba from 'routes/RoutesCucicba';
import RoutesErrors from 'routes/RoutesErrors';
import RoutesInformacion from 'routes/RoutesInformacion';
import RoutesInmobiliaria from 'routes/RoutesInmobiliaria';
import RoutesNotificaciones from 'routes/RoutesNotificaciones';
import RoutesPermisos from 'routes/RoutesPermisos';
import RoutesPropiedades from 'routes/RoutesPropiedades';
import RoutesUsuarios from 'routes/RoutesUsuarios';
import AceptarInvitacion from 'sites/admin/inmobiliario/aceptarInvitacion/AceptarInvitacion';
import ValidarToken from 'sites/admin/inmobiliario/aceptarInvitacion/ValidacionToken';
import MisEstadisticas from 'sites/admin/inmobiliario/info/misEstadisticas/MisEstadisticas';
import ProfilePage from 'sites/admin/inmobiliario/miPerfil/ProfilePage';
import { checkToken } from 'utils/checkToken';
import renderConditionalComponent from 'utils/renderConditionalComponent';
import redirectToPageBasedOnTypeOfUser from 'utils/redirectToPageBasedOnTypeOfUser';
import MainLayout from './MainLayout';

const Layout = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const token = localStorage.getItem('token_A');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentUser: userLogged, loading } = useSelector(
    state => state.login
  );
  const location = useLocation();

  useContext(AppContext);

  useEffect(() => {
    const ua = navigator.userAgent;
    if (ua.includes('Windows')) {
      HTMLClassList.add('windows');
    }
    if (ua.includes('Chrome')) {
      HTMLClassList.add('chrome');
    }
    if (ua.includes('Firefox')) {
      HTMLClassList.add('firefox');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    const scr = document.getElementById('fw-script1');
    if (userLogged && !scr) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://widget.freshworks.com/widgets/150000003490.js';
      script.async = true;
      script.defer = true;
      script.id = 'fw-script1';
      document.body.appendChild(script);

      const script2 = document.createElement('script');
      script2.type = 'text/javascript';
      script2.innerHTML = `window.fwSettings = {
        widget_id: 150000003490
      };
      !(function () {
        if ('function' != typeof window.FreshworksWidget) {
          var n = function () {
            n.q.push(arguments);
          };
          (n.q = []), (window.FreshworksWidget = n);
        }
      })();`;
      script2.id = 'fw-script2';
      document.body.appendChild(script2);

      const interval = setInterval(() => {
        if (window.FreshworksWidget) {
          clearInterval(interval);
          let nameString = userLogged.firstName + ' ' + userLogged.lastName;
          if (userLogged.matricula) {
            nameString += ' - MN ' + userLogged.matricula;
          }

          window.FreshworksWidget('identify', 'ticketForm', {
            name: nameString,
            email: userLogged.email
          });
        }
      }, 100);
    }
  }, [userLogged]);

  useEffect(() => {
    if (userLogged?.typeOfUser === 'admin' && !userLogged?.realEstateId) {
      navigate('/inmobiliaria');
    }
  }, [userLogged, navigate]);

  useEffect(() => {
    const path = location.pathname;
    if (!path.match(/restablecer/)) {
      dispatch(checkSession(navigate));
    }
  }, []);

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={<Navigate to={redirectToPageBasedOnTypeOfUser()} replace />}
        />

        <Route
          path="/ingresar"
          element={
            checkToken()[0] ? (
              <Navigate to={redirectToPageBasedOnTypeOfUser()} />
            ) : (
              <LoginInmobiliario />
            )
          }
        />

        <Route
          path="/recuperar-contrasena"
          element={
            token !== null ? <Navigate to="/perfil" /> : <ForgetPassword />
          }
        />

        <Route path="/validar-token/:token" element={<ValidarToken />} />

        <Route path="/confirmar-registro/:id" element={<AceptarInvitacion />} />

        <Route
          path="/restablecer-contrasena/:token"
          element={<RestablecerContraseña />}
        />

        <Route element={<MainLayout />}>
          <Route
            path="/estadisticas"
            element={renderConditionalComponent('Statistics', MisEstadisticas)}
          />
          {RoutesInmobiliaria()}

          {RoutesPermisos()}

          {RoutesUsuarios()}

          {RoutesPropiedades(userLogged, token)}

          {RoutesNotificaciones()}

          {RoutesInformacion()}

          {RoutesAyuda()}
          {!loading && userLogged?.typeOfUser === 'cucicba' ? (
            RoutesCucicba()
          ) : (
            <Route
              path="/usuarios/matriculados"
              element={<Navigate to="/ingresar" />}
            />
          )}

          <Route path="/perfil" element={<ProfilePage />} />

          {!loading && (
            <>
              {[
                '/perfil',
                '/home',
                '/estadisticas',
                '/permisos',
                '/permisos/roles',
                '/permisos/roles/crear',
                '/permisos/roles/editar/:id',
                '/usuarios',
                '/propiedades',
                '/propiedades/consultas',
                '/propiedades/cargar',
                '/propiedades/editar/:id',
                '/integracion'
              ].map(path => (
                <Route
                  key={path}
                  path={path}
                  element={<Navigate to="/ingresar" />}
                />
              ))}

              {RoutesErrors()}

              <Route path="*" element={<Navigate to="/errors/404" replace />} />
            </>
          )}
        </Route>
      </Routes>
    </>
  );
};

export default Layout;
